import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../shared/enums/modalId";
import DragDropUpload from "../../dragDropUpload/dragDropUpload";
import { ToastMessages } from "../../toasts/toastMessages";

interface NarIngestionReUploadProps {
  onClose: () => void;
  csv_path: string;
}

const NarIngestionReUpload = ({
  onClose,
  csv_path,
}: NarIngestionReUploadProps) => {
  const handleUploadSuccess = () => {
    toast.success(ToastMessages.NAR_INGESTION_FILE_REUPLOADED_SUCCESS);
    onClose();
  };

  return (
    <Modal
      dialogId={ModalId.NAR_INGESTION_RE_UPLOAD_MODAL}
      title="NAR Ingestion Document Re-Upload"
      onSave={() => {}}
      saveButtonText="Re-Upload"
      onClose={onClose}
      onCancel={onClose}
      cancelText="Cancel"
      hideFooter={true}
    >
      <div className="flex flex-col gap-2">
        <DragDropUpload
          id="nar-ingestion-re-upload"
          subText="Drag and drop or click to upload a new file"
          allowedFileTypes={[".pdf", ".csv"]}
          maxFileSize={10 * 1024 * 1024}
          filePath={csv_path}
          onUploadSuccess={handleUploadSuccess}
          downloadedURL={() => {}}
        />
      </div>
    </Modal>
  );
};

export default NarIngestionReUpload;
